import React from 'react';

const SlashIcon = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="32" viewBox="0 0 7 32" {...props}>
        <path fill="none" stroke="#979797" strokeLinecap="square" d="M6.5.5l-6 32" />
    </svg>
);

export default SlashIcon;



// WEBPACK FOOTER //
// ./src/components/icons/SlashIcon.js